import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoshirdicaab() {



    const cardData = {




keyword: "Mumbai to Shirdi Cab",

headingDescription: "Shreesha Tours & Travels offers safe, comfortable, and affordable Mumbai to Shirdi cab services for pilgrims, families, senior citizens, corporate travelers, and tourists. We provide one-way cabs, round-trip taxi services, same-day return trips, and customized travel packages with experienced drivers and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles to suit every travel requirement and group size. With doorstep pickup anywhere in Mumbai, flexible departure timings, transparent pricing, hassle-free booking, and 24/7 customer support, we ensure a smooth and comfortable journey to the holy town of Shirdi. Whether you are planning a Sai Baba darshan, family pilgrimage, weekend spiritual tour, or a religious trip with friends, Shreesha Tours & Travels provides reliable Mumbai to Shirdi cab services with professional chauffeurs, clean vehicles, and excellent customer service. Travelers can also customize their itinerary by including nearby religious and tourist destinations, making the journey more convenient and memorable.",

topPlaces: [
  {
    title: "Shri Sai Baba Samadhi Mandir",
    description: "Shri Sai Baba Samadhi Mandir is one of India's most visited pilgrimage destinations, attracting millions of devotees every year. The temple houses the sacred Samadhi of Sai Baba and offers a peaceful spiritual atmosphere where devotees participate in Aarti, Darshan, and various religious rituals. It is the primary attraction for visitors traveling from Mumbai to Shirdi."
  },
  {
    title: "Dwarkamai",
    description: "Dwarkamai is the historic mosque where Sai Baba spent a major part of his life. The sacred place preserves the eternal Dhuni (holy fire), stone on which Baba sat, and many historical belongings associated with him. It is one of the most spiritually significant places for Sai devotees."
  },
  {
    title: "Chavadi",
    description: "Chavadi is another important religious site connected with Sai Baba, where he used to sleep on alternate nights. The place displays several historical artifacts and remains an essential stop for devotees seeking to learn more about Baba's life and teachings."
  },
  {
    title: "Gurusthan",
    description: "Gurusthan is believed to be the place where Sai Baba was first seen meditating beneath a Neem tree. Today, it is an important spiritual destination featuring a shrine, sacred tree, and peaceful surroundings that attract devotees from across the country."
  },
  {
    title: "Lendi Baug",
    description: "Lendi Baug is a beautifully maintained garden where Sai Baba spent time every day meditating and watering plants. The peaceful pathways, trees, and eternal lamp create a calm atmosphere, making it one of the most visited attractions in Shirdi."
  },
  {
    title: "Shani Shingnapur",
    description: "Located near Shirdi, Shani Shingnapur is famous for the temple dedicated to Lord Shani and the unique tradition of homes without doors. It is one of Maharashtra's most important pilgrimage destinations and is often included in Mumbai to Shirdi cab tours."
  },
  {
    title: "Nashik",
    description: "Nashik is a major religious and tourist city famous for Trimbakeshwar Jyotirlinga, Panchavati, Sula Vineyards, and the sacred Godavari River. Many travelers combine Nashik with their Shirdi pilgrimage for a complete spiritual and sightseeing experience."
  },
  {
    title: "Trimbakeshwar Temple",
    description: "Trimbakeshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and is located near Nashik. The temple is renowned for its spiritual significance, ancient architecture, and religious ceremonies, making it a popular addition to Shirdi tour packages."
  },
  {
    title: "Bhandardara",
    description: "Bhandardara is a scenic hill destination known for Arthur Lake, Randha Falls, Wilson Dam, and lush mountain landscapes. It is an excellent stop for travelers looking to enjoy nature while returning from Shirdi."
  },
  {
    title: "Igatpuri",
    description: "Igatpuri is a picturesque hill station in the Western Ghats famous for its misty mountains, waterfalls, trekking trails, and Vipassana International Academy. It is a popular destination for families, couples, and nature lovers traveling between Mumbai and Shirdi."
  }
],




"services": [
  {
    "name": "Mumbai to Shirdi Cab",
    "description": "Book Mumbai to Shirdi Cab for safe, comfortable, and reliable pilgrimage travel with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova Crysta, and SUV cabs for family trips, temple visits, and one way or round trip journeys."
  },
  {
    "name": "Mumbai to Shirdi Taxi",
    "description": "Hire Mumbai to Shirdi Taxi for smooth and convenient travel with experienced drivers, affordable fares, and comfortable AC vehicles for every journey."
  },
  {
    "name": "Mumbai to Shirdi Taxi Fare",
    "description": "Check Mumbai to Shirdi Taxi Fare with transparent pricing, budget-friendly packages, and no hidden charges for one way and round trip travel."
  },
  {
    "name": "Mumbai to Shirdi Car Rental",
    "description": "Book Mumbai to Shirdi Car Rental with chauffeur-driven vehicles for comfortable family travel, pilgrimage tours, and business trips."
  },
  {
    "name": "Mumbai to Shirdi Taxi Service",
    "description": "Choose Mumbai to Shirdi Taxi Service for reliable transportation with professional drivers, premium vehicles, and flexible booking options."
  },
  {
    "name": "Mumbai to Shirdi Cabs Round Trip",
    "description": "Reserve Mumbai to Shirdi Cabs Round Trip with affordable return packages, experienced chauffeurs, and comfortable AC vehicles for temple visits."
  },
  {
    "name": "Mumbai to Shirdi Taxi Innova Fare",
    "description": "Check Mumbai to Shirdi Taxi Innova Fare for spacious Innova and Innova Crysta cabs with transparent pricing and premium travel comfort."
  },
  {
    "name": "Mumbai to Shirdi Cab Service",
    "description": "Book Mumbai to Shirdi Cab Service with reliable chauffeurs, clean vehicles, and flexible one way and round trip travel options."
  },
  {
    "name": "Mumbai to Shirdi Taxi Cost",
    "description": "Get Mumbai to Shirdi Taxi Cost with affordable pricing, quality vehicles, and professional drivers for a safe and comfortable journey."
  },
  {
    "name": "Mumbai Airport to Shirdi Taxi",
    "description": "Hire Mumbai Airport to Shirdi Taxi with direct airport pickup, experienced chauffeurs, and comfortable AC vehicles for hassle-free travel."
  },
  {
    "name": "Mumbai Airport to Shirdi Taxi Fare",
    "description": "Check Mumbai Airport to Shirdi Taxi Fare with competitive pricing and convenient airport transfer services for pilgrims and families."
  },
  {
    "name": "Mumbai to Shirdi Taxi Price",
    "description": "Find Mumbai to Shirdi Taxi Price with flexible packages, premium vehicles, and transparent rates for every travel requirement."
  },
  {
    "name": "Mumbai to Shirdi Taxi One Way",
    "description": "Book Mumbai to Shirdi Taxi One Way for economical single-trip travel with fixed pricing and comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Shirdi by Car Fare",
    "description": "Check Mumbai to Shirdi by Car Fare with affordable pricing and quality chauffeur-driven transportation for a relaxing journey."
  },
  {
    "name": "Mumbai to Shirdi Cab Fare",
    "description": "Get Mumbai to Shirdi Cab Fare with competitive rates, experienced drivers, and multiple vehicle choices for comfortable travel."
  },
  {
    "name": "Mumbai to Shirdi by Car",
    "description": "Travel Mumbai to Shirdi by Car with premium AC vehicles, professional chauffeurs, and flexible travel schedules for a smooth trip."
  },
  {
    "name": "Mumbai to Shirdi Cab Price",
    "description": "Check Mumbai to Shirdi Cab Price with affordable travel packages, transparent billing, and premium chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai Airport to Shirdi by Car",
    "description": "Book Mumbai Airport to Shirdi by Car with direct pickup, experienced drivers, and comfortable vehicles for stress-free airport transfers."
  },
  {
    "name": "Mumbai Shirdi Car Rental",
    "description": "Choose Mumbai Shirdi Car Rental for reliable chauffeur-driven travel with spacious vehicles suitable for families and pilgrimage groups."
  },
  {
    "name": "Mumbai to Shirdi Cab Booking",
    "description": "Complete Mumbai to Shirdi Cab Booking online with instant confirmation, multiple vehicle options, and reliable customer support."
  },
  {
    "name": "Mumbai to Shirdi Cab Booking Online",
    "description": "Reserve Mumbai to Shirdi Cab Booking Online with simple booking, instant confirmation, and affordable travel packages."
  },
  {
    "name": "Mumbai to Shirdi Cab Booking Price",
    "description": "Check Mumbai to Shirdi Cab Booking Price with transparent fares, quality vehicles, and budget-friendly travel options."
  },
  {
    "name": "Mumbai to Shirdi Car Booking",
    "description": "Book Mumbai to Shirdi Car Booking with chauffeur-driven vehicles, comfortable seating, and flexible pickup schedules."
  },
  {
    "name": "Mumbai to Shirdi Car Hire",
    "description": "Hire Mumbai to Shirdi Car Hire for private travel with experienced chauffeurs and premium AC vehicles for family and corporate trips."
  },
  {
    "name": "Mumbai to Shirdi Car Package",
    "description": "Choose Mumbai to Shirdi Car Package with economical one way and round trip options, comfortable vehicles, and professional drivers."
  },
  {
    "name": "Mumbai to Shirdi Car Rental Price",
    "description": "Check Mumbai to Shirdi Car Rental Price with affordable rates, premium vehicles, and transparent pricing for every journey."
  },
  {
    "name": "Mumbai to Shirdi Innova Fare",
    "description": "Get Mumbai to Shirdi Innova Fare with spacious Innova and Innova Crysta vehicles ideal for family and group travel."
  },
  {
    "name": "Mumbai to Shirdi Return Cab Fare",
    "description": "Find Mumbai to Shirdi Return Cab Fare with economical round trip packages and comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Shirdi Taxi Charges",
    "description": "Check Mumbai to Shirdi Taxi Charges with competitive pricing, professional drivers, and reliable outstation taxi services."
  },
  {
    "name": "Mumbai to Shirdi Round Trip Taxi Fare",
    "description": "Book Mumbai to Shirdi Round Trip Taxi Fare with affordable return packages and premium AC vehicles for convenient pilgrimage travel."
  },
  {
    "name": "Mumbai to Shirdi Taxi Travel Time",
    "description": "Know Mumbai to Shirdi Taxi Travel Time and enjoy a comfortable road journey with experienced chauffeurs and reliable vehicles."
  },
  {
    "name": "Taxi from Mumbai Airport to Shirdi",
    "description": "Reserve Taxi from Mumbai Airport to Shirdi with direct airport pickup, clean vehicles, and professional chauffeurs for comfortable travel."
  },
  {
    "name": "Taxi Service from Mumbai to Shirdi",
    "description": "Book Taxi Service from Mumbai to Shirdi for dependable long-distance transportation with affordable fares, premium vehicles, and experienced drivers."
  }
],
"tableData": [
  ["Mumbai to Shirdi Cab", "Mumbai to Shirdi Taxi"],
  ["Mumbai to Shirdi Taxi Fare", "Mumbai to Shirdi Car Rental"],
  ["Mumbai to Shirdi Taxi Service", "Mumbai to Shirdi Cabs Round Trip"],
  ["Mumbai to Shirdi Taxi Innova Fare", "Mumbai to Shirdi Cab Service"],
  ["Mumbai to Shirdi Taxi Cost", "Mumbai Airport to Shirdi Taxi"],
  ["Mumbai Airport to Shirdi Taxi Fare", "Mumbai to Shirdi Taxi Price"],
  ["Mumbai to Shirdi Taxi One Way", "Mumbai to Shirdi by Car Fare"],
  ["Mumbai to Shirdi Cab Fare", "Mumbai to Shirdi by Car"],
  ["Mumbai to Shirdi Cab Price", "Mumbai Airport to Shirdi by Car"],
  ["Mumbai Shirdi Car Rental", "Mumbai to Shirdi Cab Booking"],
  ["Mumbai to Shirdi Cab Booking Online", "Mumbai to Shirdi Cab Booking Price"],
  ["Mumbai to Shirdi Car Booking", "Mumbai to Shirdi Car Hire"],
  ["Mumbai to Shirdi Car Package", "Mumbai to Shirdi Car Rental Price"],
  ["Mumbai to Shirdi Innova Fare", "Mumbai to Shirdi Return Cab Fare"],
  ["Mumbai to Shirdi Taxi Charges", "Mumbai to Shirdi Round Trip Taxi Fare"],
  ["Mumbai to Shirdi Taxi Travel Time", "Taxi from Mumbai Airport to Shirdi"],
  ["Taxi Service from Mumbai to Shirdi", ""]
],




whychoose: [
  {
    WhyChooseheading: "Trusted Mumbai to Shirdi Cab Service",
    WhyChoosedescription: "Shreesha Tours & Travels provides dependable Mumbai to Shirdi cab services with comfortable vehicles, courteous drivers, and convenient travel options for pilgrims, families, and corporate travellers."
  },
  {
    WhyChooseheading: "Perfect for Sai Baba Darshan Trips",
    WhyChoosedescription: "Travel peacefully to Shirdi Sai Baba Temple with a private cab that offers flexible departure timings, comfortable seating, and a stress-free pilgrimage experience."
  },
  {
    WhyChooseheading: "Wide Choice of Comfortable Vehicles",
    WhyChoosedescription: "Select from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium cars according to your group size and luggage requirements."
  },
  {
    WhyChooseheading: "One Way & Round Trip Taxi Options",
    WhyChoosedescription: "Book a one-way taxi to Shirdi or choose a round-trip package with return on the same day or a later date based on your travel schedule."
  },
  {
    WhyChooseheading: "Professional Drivers for Highway Travel",
    WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, punctual pickups, and a smooth journey on the Mumbai to Shirdi route."
  },
  {
    WhyChooseheading: "Customizable Pilgrimage Tour",
    WhyChoosedescription: "You can include nearby destinations such as Shani Shingnapur, Nashik, Trimbakeshwar, Grishneshwar Temple, or Ellora Caves as part of your customized travel itinerary."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained Fleet",
    WhyChoosedescription: "Our vehicles are regularly serviced, feature clean interiors, spacious seating, and are ideal for long-distance religious and family travel."
  },
  {
    WhyChooseheading: "Easy Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Enjoy quick booking assistance, transparent pricing, and dedicated customer support for your Mumbai to Shirdi cab reservation."
  }
]

};

const faqData = [
  {
    question: "Does Shreesha Tours & Travels provide Mumbai to Shirdi Cab Service?",
    answer: "Yes, we offer Mumbai to Shirdi cab services for one-way, round-trip, pilgrimage, and customized travel requirements."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Shirdi?",
    answer: "Yes, one-way taxi services are available for passengers travelling directly from Mumbai to Shirdi."
  },
  {
    question: "Which vehicles are available for Mumbai to Shirdi travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Is the cab suitable for family pilgrimage trips?",
    answer: "Yes, our comfortable and spacious vehicles are ideal for families, senior citizens, devotees, and groups visiting Shirdi."
  },
  {
    question: "Can I book a same-day return trip from Shirdi?",
    answer: "Yes, same-day and multi-day round-trip taxi packages are available according to your travel plans."
  },
  {
    question: "Can I visit Shani Shingnapur along with Shirdi?",
    answer: "Yes, you can customize your itinerary to include Shani Shingnapur, Nashik, Trimbakeshwar, and other nearby pilgrimage destinations."
  },
  {
    question: "Do you provide pickup from Mumbai Airport and hotels?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, homes, offices, and other preferred locations."
  },
  {
    question: "Are tolls and parking charges included in the fare?",
    answer: "Toll charges, parking fees, state permits, and other applicable charges depend on the selected package and are shared during booking."
  },
  {
    question: "Is Mumbai to Shirdi cab service available every day?",
    answer: "Yes, Shreesha Tours & Travels provides daily cab services based on advance booking and vehicle availability."
  },
  {
    question: "How can I book a Mumbai to Shirdi Cab?",
    answer: "Share your travel date, pickup location, passenger details, preferred vehicle, and trip type to receive your fare quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Patil",
    feedback: "We travelled from Mumbai to Shirdi with Shreesha Tours & Travels for Sai Baba Darshan. The cab was clean, the driver was polite, and the journey was peaceful and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anita Joshi",
    feedback: "Excellent service from booking to drop-off. The Innova Crysta was spacious, pickup was on time, and our Shirdi pilgrimage was completely hassle-free.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Shirdi Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-shirdi-cab.webp",
  "description":
    "Book Mumbai to Shirdi Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Shirdi with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for Sai Baba temple darshan, family trips, pilgrimage tours, and weekend travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-shirdi-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Mumbai to Shirdi Cab | Pilgrimage Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Shirdi Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable Mumbai to Shirdi travel with 24x7 online cab booking and comfortable Sai Baba temple trips."
  />

  <meta
    name="keywords"
    content="Mumbai to Shirdi Cab, Mumbai to Shirdi Taxi, Mumbai to Shirdi Taxi Fare, Mumbai to Shirdi Car Rental, Mumbai to Shirdi Taxi Service, Mumbai to Shirdi Cabs Round Trip, Mumbai to Shirdi Taxi Innova Fare, Mumbai to Shirdi Cab Service, Mumbai to Shirdi One Way Cab, Mumbai to Shirdi Taxi Booking, Mumbai to Shirdi Innova Crysta Cab, Mumbai to Shirdi Outstation Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoshirdicaab;